var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPassportMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5C12.5 8.30653 12.0259 7.16193 11.182 6.31802C10.3381 5.47411 9.19347 5 8 5M12.5 9.5C12.5 10.0909 12.3836 10.6761 12.1575 11.2221C11.9313 11.768 11.5998 12.2641 11.182 12.682C10.7641 13.0998 10.268 13.4313 9.72208 13.6575C9.17611 13.8836 8.59095 14 8 14M12.5 9.5C12 10 10.5 10.5 8 10.5C5.5 10.5 4 10 3.5 9.5M8 5C6.80653 5 5.66193 5.47411 4.81802 6.31802C3.97411 7.16193 3.5 8.30653 3.5 9.5M8 5C8.966 5 9.75 7.015 9.75 9.5C9.75 11.985 8.966 14 8 14M8 5C7.034 5 6.25 7.015 6.25 9.5C6.25 11.985 7.034 14 8 14M8 14C6.80653 14 5.66193 13.5259 4.81802 12.682C4.40016 12.2641 4.06869 11.768 3.84254 11.2221C3.6164 10.6761 3.5 10.0909 3.5 9.5M14.5 0.5H15V18.5H1V0.5H14.5Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPassportMore);
export default __webpack_public_path__ + "static/media/ic_passport_more.e6be906bc39655e4d5b7ec4db04e36f2.svg";
export { ForwardRef as ReactComponent };